import { adjustImage } from '../../utils/adjust-image';
import { toNormalizedHueSatBr } from '../../utils/color';
export default function (name, color) {
    const { br, hue, sat } = toNormalizedHueSatBr(color);
    // NOTE: Make sure that ImageWithLoader from composer still works if you change this.
    const imageProps = {
        w: 750,
        h: 750,
        // FYI: adding params in different order might cause different result;
        br,
        sat,
        hue,
        lg: 0,
    };
    const iconMap = {
        facebook: 'a306cb_6f69311272764c9094f1795b992fa3c1~mv2.png',
        instagram: 'a306cb_a46fa514003c41ab906638635f992277~mv2.png',
        linkedIn: 'a306cb_7b0500cdfdbc403aa4c14e91550e6b6b~mv2.png',
        pinterest: 'a306cb_79f84f821f77463ab351de4ced289e86~mv2.png',
        soundCloud: 'a306cb_2d53ba83d1ae4594999458d0d2a7dc4c~mv2.png',
        twitter: '5e9922_88126427794648a2835ac81ee861a6ba~mv2.png',
        youtube: 'a306cb_415ce174e5ca4c9181eb4a1133533636~mv2.png',
        tiktok: '5e9922_59f4ab7f762a4030b6dc3f5cc21d77a7~mv2.png',
    };
    return adjustImage(iconMap[name], imageProps);
}
//# sourceMappingURL=get-social-icon-url.js.map